<script lang="ts">
import type { MaybeComputedElementRef } from "@vueuse/core";
import type { VariantProps } from "class-variance-authority";
import type { TextInputBaseProps } from "./textInputBase";
import type { TextFieldAutosProps } from "./useTextFieldAutos";
import { cva, cx } from "class-variance-authority";
import { useForwardExpose } from "reka-ui";
import { textInputBase } from "./textInputBase";
import { useTextFieldAutos } from "./useTextFieldAutos";

const base = cva([], {
  variants: {},
});
type TextFieldBaseProps = VariantProps<typeof base>;

export type TextAreaProps = TextInputBaseProps & TextFieldBaseProps;
const textArea = (tfProps: TextAreaProps) => cx(textInputBase(tfProps), base(tfProps));
</script>

<script setup lang="ts">
defineOptions({
  inheritAttrs: false,
});

const props = defineProps<{
  variant?: TextAreaProps["variant"];
  size?: TextAreaProps["size"];
  autoresize?: boolean;
  disabled?: boolean;
  placeholder?: string;
} & TextFieldAutosProps>();

const model = defineModel<string>();
const { forwardRef, currentRef } = useForwardExpose();

useTextFieldAutos(currentRef as MaybeComputedElementRef<HTMLInputElement>, {
  autofocus: () => props.autofocus,
  autoselect: () => props.autoselect,
});
</script>

<template>
  <div
    v-if="autoresize"
    class="grid min-h-0 w-full min-w-0"
  >
    <textarea
      :ref="forwardRef"
      v-bind="$attrs"
      v-model="model"
      :placeholder="placeholder"
      :style="{
        'grid-area': '1 / 1 / 2 / 2',
      }"
      rows="1"
      class="resize-none"
      :class="textArea({ variant, size })"
    />
    <div
      v-bind="$attrs"
      class="invisible wrap-anywhere whitespace-pre-wrap"
      :style="{
        'grid-area': '1 / 1 / 2 / 2',
      }"
      :class="textArea({ variant, size })"
    >
      {{ `${model} ` }}
    </div>
  </div>
  <textarea
    v-else
    :ref="forwardRef"
    v-model="model"
    v-bind="$attrs"
    :disabled="disabled"
    :placeholder="placeholder"
    :class="textArea({ variant, size })"
  />
</template>
